/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Return the parent state name of a given state name.
 */
export function getParentStateName(stateName: string): string {
    const stateNameParts = stateName.split('.');

    return stateNameParts.slice(0, stateNameParts.length - 1).join('.');
}
